<div class="{{baseSiteId}} {{device}}">
    <input type="hidden" id="siteIdDecibel" [value]="baseSiteId">
    <input type="hidden" name="registerIsAnonymous" [value]="isUserLoggedIn">
    <input type="hidden" id="selectedLocationUid" [value]="b2bUidSelectedLoc">
    <input type="hidden" id="fsShipNowProducts" [value]="userDetailsData?.defaultB2BUnit?.futureShip">
    <input type="hidden" id="isMultiLocation" [value]="multiLoc">
    <input type="hidden" id="isSingleLocation" [value]="singleLoc">
    <input type="hidden" id="shipToAccountNumber" [value]="b2bUidSelectedLoc">
    <input type="hidden" id="corporateStore" [value]="companyName">
    <input type="hidden" id="userLogin" [value]="userId">

    <!-- Global Release Banner -->
    <app-release-banner></app-release-banner>

    <cx-storefront [class]="activeSite$ | async"></cx-storefront>
</div>
